import { useQuery } from '@sequencehq/api'
import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'

export const useStripeIntegration = () => {
  const stripeIntegration = useQuery(
    dashboard20240730Client.getIntegration,
    'Stripe'
  )

  return {
    enabled: stripeIntegration.data?.state === 'CONNECTED',
    isLoading: stripeIntegration.isLoading
  }
}
